// @flow

import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import SortableItem from "./SortableItem";
import * as R from "ramda";
import { SortableList as StyledSortableList } from "./styles";

type Props = {
  items: Array<{ key: string, active: boolean }>,
  itemIds: string[],
  handleCheckbox: Function,
  fixedColumns?: $ReadOnlyArray<string>,
};

const SortableList = ({
  items,
  itemIds,
  handleCheckbox,
  fixedColumns = ([]: $ReadOnlyArray<string>),
}: Props) => (
  <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
    <StyledSortableList>
      {items.map((column, index) => (
        <SortableItem
          key={itemIds[index]}
          id={itemIds[index]}
          column={column}
          handleCheckbox={handleCheckbox}
          isReadOnly={R.includes(column.key, fixedColumns)}
        />
      ))}
    </StyledSortableList>
  </SortableContext>
);

export default SortableList;
